module.exports = __webpack_public_path__ + "static/media/trouble.7cb0a98.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/trouble.mp3
// module id = 4sj5
// module chunks = 0